<ng-template #template let-row="row">
  <div class="flex--column" *ngIf="!editable">
    <div class="flex--column" *ngIf="row?.deliveryInformation?.deliveryDate as deliveryDate">
      <span *ngIf="!isRushEmergencyCart && row?.deliveryInformation | formatFlexibilityDate as minimumDate; else noFlexibility">
        {{ minimumDate }} - {{ deliveryDate | agrDate }}
      </span>
      <ng-template #noFlexibility>
        {{ deliveryDate | agrDate }}
      </ng-template>
    </div>
  </div>

  <div class="flex--column" *ngIf="editable && orderType === returnableOrderType">
    {{ row?.deliveryInformation?.deliveryDate | agrDate }}
  </div>
  <div class="delivery-button flex--column">
    <button
      mat-button
      data-test="column-delivery-date__delivery-moment"
      class="button--icons"
      (click)="openDeliveryDate(row)"
      *ngIf="editable && orderType !== returnableOrderType"
    >
      <ng-container *ngIf="!row?.deliveryInformation?.deliveryDate">
        <mat-icon>add</mat-icon>
        <span>{{ 'cart-column-delivery-date.add-delivery-moment' | translate }}</span>
      </ng-container>
      <ng-container *ngIf="row?.deliveryInformation?.deliveryDate">
        <mat-icon *ngIf="!isRushEmergencyCart">edit</mat-icon>
        <span>{{ row?.deliveryInformation?.deliveryDate | agrDate }}</span>
        <mat-icon *ngIf="isRushEmergencyCart">help_outline</mat-icon>
      </ng-container>
    </button>
    <div class="text--label" *ngIf="editable && row?.deliveryInformation | formatFlexibilityDate as minimumDate">
      {{ minimumDate }} -
      {{ row?.deliveryInformation?.deliveryDate | agrDate }}
    </div>
  </div>
</ng-template>
